"use client";

import { RouteError } from "@/components/route-error";

// Catches failures in app/(dashboard)/layout.tsx (e.g. nav data when the backend is down), which
// app/(dashboard)/error.tsx can't: a segment's error boundary sits below its own layout.
export default RouteError;
